import { mapArrayToLabelValue } from "@primaria/plugins-core";
import { Store } from "@reduxjs/toolkit";
import { IActivityHistoryItem } from "../../domain/model";
import { upFilterId } from "../model";
import { activityHistoryFiltersSlice } from "../slice";

export const getUpFilter = (items: IActivityHistoryItem[]) => {
  const allUps = items
    .flatMap((item) => item.up ?? [])
    .filter((up) => up?.id?.trim()) // Filtrar UPs que tienen ID válido (no vacío ni solo espacios)
    .filter((up, index, self) => index === self.findIndex((u) => u.id === up.id)); // Filtrar duplicados

  if (allUps.length > 0) {
    const newUpFilter = {
      id: upFilterId,
      title: "UP",
      values: mapArrayToLabelValue(allUps, "description", "id"),
      enabledValues: [],
    };

    return newUpFilter;
  }
};

export const handleAddUpFilter = (items: IActivityHistoryItem[], store: Store) => {
  const newUpFilter = getUpFilter(items);
  if (newUpFilter)
    store.dispatch(activityHistoryFiltersSlice.actions.addUpFilters(newUpFilter));
};
